<template>
  <a-button
    v-if="canViewPurchasePrice"
    size="small"
    :type="purchasePriceVisible ? 'default' : 'primary'"
    @click="togglePurchasePriceVisible"
  >
    <a-icon :type="purchasePriceVisible ? 'eye-invisible' : 'eye'" />
    {{ purchasePriceVisible ? '隐藏进货价' : '显示进货价' }}
  </a-button>
</template>

<script>
import purchasePriceVisibility from '@/mixins/purchasePriceVisibility'

export default {
  name: 'PurchasePriceToggle',
  mixins: [purchasePriceVisibility],
}
</script>
